<template>
  <el-form
    :model="form"
    :rules="rules"
    ref="mobile"
    size="small"
    label-position="left"
    label-width="230px"
  >
    <p class="fields-title" style="border-bottom: 1px solid #f1f1f1;padding-bottom:10px">Vous devez saisir les informations ci-dessous pour résilier votre abonnement :</p>

    <el-form-item prop="contract" required>
      <span slot="label" class="label-logo">
        Votre numéro de carte <img :src="logo" :class="classname" />
      </span>
      <el-input v-model="form.contract" />
      <span class="notice">
        <i class="el-icon-info" /> Le numéro de carte se trouve sur votre carte de membre.
      </span>
    </el-form-item>

    <Cgu
      id="cgu"
      :rows="8"
      :contact="contact"
      currency="eur"
    />

    <el-form-item class="cgu" prop="cgu">
      <el-checkbox v-model="form.cgu">
        J'ai lu et j'accepte les conditions générales ci-dessus
      </el-checkbox>
    </el-form-item>

    <div class="valider">
      <el-button
        round
        icon="el-icon-caret-right"
        type="danger"
        :loading="loading"
        @click.prevent="valide"
      >
        Je valide ma demande
      </el-button>

      <img src="../../assets/images/secure-payment.png" />
    </div>
  </el-form>
</template>

<script>
import Cgu from '../cgu.vue'

export default {
  props: {
    contract: String,
    loading: Boolean,
    contact: String,
    type: String,
    description: String,
    reference: String
  },
  components: {
    Cgu
  },
  data () {
    const cgu = (rule, value, callback) => {
      if (value !== true) {
        callback(new Error('Vous devez lire et accepter les conditions générales'))
      } else {
        callback()
      }
    }
    return {
      defaultType: this.type,
      form: {
        contract: this.contract,
        type: this.type,
        cgu: false
      },
      rules: {
        contract: [
          { required: true, message: 'Saisissez votre ' + this.reference, trigger: 'blur' }
        ],
        cgu: [
          { validator: cgu, trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    logo () {
      return '/static/images/logos/' + this.classname + '.png'
    },
    dialogclass () {
      return 'pre-select ' + this.classname + '-select'
    },
    classname () {
      return this.description.replace(/\s+/g, '').toLowerCase()
    }
  },
  methods: {
    valide () {
      this.$refs.mobile.validate((valid) => {
        if (valid) {
          this.$emit('valide', this.form)
        }
      })
    },
    close () {
      this.popup = false
    }
  },
  watch: {
    contract (value) {
      this.form.contract = value
    },
    type (value) {
      this.form.type = value
    },
    form: {
      handler (value) {
        if (value) {
          this.$emit('update:type', value.type)
          this.$emit('update:contract', value.contract)
        }
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
  #cgu {
    height: 8em;
    overflow: auto;
    max-width: 600px;
    margin: 50px auto 30px;
    text-align: left;
    font-size: 11px;
  }
  .valider {
    img {
      max-width: 250px;
      margin-top: 25px;
    }
  }
  .delai {
    margin-top: 40px;
    color: #000;
    font-size: 14px;

    .legal {
      font-size: 10px;
      display: block;
    }
  }
  .notice {
    color: #444;
    font-size: 12px;
  }
  .el-select {
    width: 100%;
  }
  .choice {
    padding: 50px 0;
  }
</style>

<style lang="scss">
  .el-form-item.cgu {
    max-width: 600px;
    margin: 0 auto 15px !important;

    .el-form-item__content {
      padding-top: 10px;
      margin-left: 0 !important;
      text-align: center;
    }
    .el-checkbox__label {
      font-weight: bold;
      font-size: 16px;
    }
  }
  .choice-logo {
    position: relative;

    .el-radio {
      padding-bottom: 55px;
    }
    img {
      max-height: 24px;
      display: block;
      margin: 8px auto 0;
    }
  }
  .label-logo {
    position: relative;

    img {
      max-height: 24px;
      position: absolute;
      left: 110px;
      top: -3px;

      &.basicfit {
        max-height: 50px;
        left: 150px;
        top: -17px;
      }
      &.neoness {
        max-height: 50px;
        left: 150px;
        top: -17px;
      }
      &.keepcool {
        max-height: 50px;
        left: 150px;
        top: -17px;
      }
      &.fitnesspark {
        max-height: 50px;
        left: 150px;
        top: -17px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/form/sport.vue